import { withPopup } from '../lib/popup';

import SellitemMoveStep from './SellitemMoveStep';

export default withPopup(SellitemMoveStep);
